export { finiteSvgNumber, finiteSvgViewBox, svgDivisor } from "#finite-svg-number";
